import React from 'react';
import { SxStyle } from '../../../../types';
import { useStringsContext } from '../../../../contexts/strings';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const styles: SxStyle = {
  popover: (theme) => ({
    backgroundColor: theme.palette.error.main,
    padding: '10px',
  }),
  icon: (theme) => ({
    color: theme.palette.contrast.main,
  }),
  text: (theme) => ({
    color: theme.palette.contrast.main,
    maxWidth: '400px',
  }),
};

interface Props {
  showPopover: boolean;
  onClose: () => void;
  anchorElRef: any;
  /** Shown instead of the generic validation error */
  message?: string;
}

const PollValidationPopover = ({ showPopover, onClose, anchorElRef, message }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Popover
      open={showPopover}
      elevation={0}
      anchorEl={anchorElRef}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 70,
        horizontal: 'center',
      }}
    >
      <Box sx={styles.popover}>
        <Stack direction="row" spacing={4} alignItems="center">
          <ErrorOutlineIcon sx={styles.icon} />
          <Typography variant="body2" sx={styles.text}>
            {message ?? strings.polls.saveValidationError}
          </Typography>
          <Button variant="text" color="contrast" onClick={onClose}>
            {strings.actions.ok}
          </Button>
        </Stack>
      </Box>
    </Popover>
  );
};

export default PollValidationPopover;
